import React, { Component } from "react";
import { connect } from "react-redux";
import AdrLocMiscMaterialsRowV3 from "./AdrLocMiscMaterialsRowV3";
import { Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ADR_EDIT } from "../../_constants/actionConstants";

class AdrLocMiscMaterialsV3 extends Component {
  handleClick_add = (e) => {
    const {
      dispatch,
      tabId,
      wpTabId,
      locationWorkPerformed: locWp,
      markAdrDirty,
    } = this.props;
    e.preventDefault();
    dispatch({
      type: ADR_EDIT.LOCATION_WORKPERFORMED.MISC_MATERIALS.ADD,
      tabId,
      wpTabId,
      clientId: locWp.clientId,
    });
    markAdrDirty();
  };

  handleClick_delete = (locMmIndex) => (e) => {
    const {
      dispatch,
      tabId,
      wpTabId,
      locationWorkPerformed: locWp,
      markAdrDirty,
    } = this.props;
    e.preventDefault();
    dispatch({
      type: ADR_EDIT.LOCATION_WORKPERFORMED.MISC_MATERIALS.DELETE,
      tabId,
      wpTabId,
      clientId: locWp.clientId,
      locMmIndex,
    });
    markAdrDirty();
  };

  render() {
    const {
      idSuffix,
      showLmmBlock,
      toggleLmmBlock,
      projectId,
      tabId,
      wpTabId,
      locationWorkPerformed: locWp,
      status,
      markAdrDirty,
    } = this.props;
    const miscMaterials = locWp.miscMaterials || [];

    return (
      <div className="locwp-row-mm">
        <div className="card mb-2 w-100 bg-lightpink">
          <div className="card-body p-2">
            <div
              id={`lmmToggler_${idSuffix}`}
              className="mb-0 loc-wp-subsection-toggler"
              onClick={toggleLmmBlock}
            >
              <FontAwesomeIcon
                icon={showLmmBlock ? "caret-down" : "caret-right"}
                className="fa-fw mr-1"
              />
              <b>
                <i>Miscellaneous Materials Used</i>
              </b>
              <span className="badge badge-pill badge-danger my-auto ml-2">
                {miscMaterials && miscMaterials.length}
              </span>
            </div>
            <Collapse isOpen={showLmmBlock}>
              <hr className="mb-0 mt-1" />
              <div className="locwp-row-mm__table">
                <div className="locwp-row-mm__tr">
                  <div className="locwp-row-mm__td--desc">
                    <span>
                      <b>Description</b>
                    </span>
                  </div>
                  <div className="locwp-row-mm__td--vendor">
                    <span>
                      <b>Vendor</b>
                    </span>
                  </div>
                  <div className="locwp-row-mm__td--invoice">
                    <span>
                      <b>Invoice #</b>
                    </span>
                  </div>
                  <div className="locwp-row-mm__td--qty">
                    <span>
                      <b>Qty</b>
                    </span>
                  </div>
                  <div className="locwp-row-mm__td--uom">
                    <span>
                      <b>Unit</b>
                    </span>
                  </div>
                  <div className="locwp-row-mm__td--del">
                    {/* Create a hidden dummy button to reserve spacing. This is
                        required to align table headers with the fields. */}
                    <button
                      name="dummyDelLocMm"
                      id={`dummyDelLocMm`}
                      className="btn btn-outline-danger px-2 py-0"
                      style={{ visibility: "hidden" }}
                      type="button"
                      onClick={() => {}}
                      disabled
                    >
                      <FontAwesomeIcon icon="times" className="fa-fw" />
                    </button>
                  </div>
                </div>
                {miscMaterials &&
                  miscMaterials.map((locMm, index) => (
                    <AdrLocMiscMaterialsRowV3
                      key={`locMmRow_${index}_${locMm.locationWorkPerformedLocationId}`}
                      locMmIndex={index}
                      miscMaterial={locMm}
                      handleClick_delete={this.handleClick_delete}
                      projectId={projectId}
                      tabId={tabId}
                      wpTabId={wpTabId}
                      clientId={locWp.clientId}
                      status={status}
                      markAdrDirty={markAdrDirty}
                    />
                  ))}
              </div>
              <hr className="my-2" />
              <button
                type="button"
                name="addLocMiscMaterialsRow"
                id={`addLocMmRow_${idSuffix}`}
                className="btn btn-outline-secondary"
                onClick={this.handleClick_add}
                disabled={this.props.status.isDisabled}
              >
                Add New Misc. Materials
              </button>
            </Collapse>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(AdrLocMiscMaterialsV3);
